import { Component, OnInit } from "@angular/core";
import { ApiPartnerService } from "../../api/api-partner.service";
import { ActivatedRoute, Router, ParamMap } from "@angular/router";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  NgForm,
  ValidatorFn,
  EmailValidator,
  Validators,
} from "@angular/forms";
// import { FormControl} from '@angular/forms';
import { LoadJsService } from "../../load-js/load-js.service";
import { URLSearchParams } from "@angular/http";

@Component({
  selector: "app-manage-user-nextsys",
  templateUrl: "./manage-user-nextsys.component.html",
  styleUrls: ["./manage.component.css"],
})
export class ManageusernextsysComponent implements OnInit {
  textSearch = new FormControl("");

  //pagination
  //paging_link : any = [];
  CheckAll = false;
  CheckUser: any = {};

  flagging: any = {};

  paging: any = {};
  msearch: string;
  mrole: string = "All";
  limit = 10;

  page_self = [];
  page_next = [];
  page_prev = [];
  meta = [];
  last_index: number;
  first_index: number;
  total_count: number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = "";
  searchQueryParams = "";
  href = "";
  //end pagination
  roleValue = "";
  partnerValue = false;
  wicValue = false;

  userList: any = {};
  itemupdate: any = {};
  itemedit: any = {};
  itemdelete: any = {};
  itemdirectsales: any = {};
  response: any = {};
  data_partner: any = [];
  partnerwtowic: any = [];
  partnerwitwic: any = [];
  partnersuperbranch: any = [];
  listpartner: any = [];
  data_role: any = [];
  alert_act: any = [];
  value: any = [];

  isOne = false;
  alert_failed = false;
  alert_success = false;

  table_load = true;

  formRegister = this.fb.group({
    // id: [''],
    username: [""],
    email: ["", [Validators.required]],
    password: [""],
    partner: [""],
    salescode: [""],
    role: [""],
  });

  formPartner = {
    partner: [Validators.required],
    unpartner: [],
  };

  formUpdate = this.fb.group({
    username: [""],
    password: ["mncplaymedia2019"],
    confirm: [""],
    // id: [''],
    // username: [{
    //   value: '',
    //   disabled: true
    // }],
    // email: [''],
    // password: [{
    //   value: 'mncplay2019',
    //   disabled: true
    // }],
    // partner: [''],
    // role: [''],
  });
  formEdit = this.fb.group({
    username: [""],
    email: ["", [Validators.required]],
  });

  formDirect = this.fb.group({
    username: [""],
    salescode: [""],
    nama: [""],
    nohp: [""],
    kota: [""],
    branch: [""],
  });

  successreg: string;
  errorreg: string;
  confirmation = false;

  scodenotavail = false;
  scodeavail = false;
  usernamenotavail = false;
  usernameavail = false;
  emailnotavail = false;
  emailavail = false;
  emailfalse = false;

  constructor(
    public partnerService: ApiPartnerService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    public LoadJs: LoadJsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.loadStart();
  }

  loadStart() {
    this.route.queryParams
      //.filter(params => params.order)
      .subscribe((params) => {
        // console.log(params); // {order: "popular"}

        //this.order = params.order;
        //console.log(this.order); // popular
        this.CheckUser = {};
        this.CheckAll = false;

        if (
          (params.search != "" || params.mrole != "") &&
          params.search != undefined
        ) {
          // console.log('search');
          // console.log(params.search);
          this.msearch = params.search;
          this.mrole = params.mrole;
          this.querySearch = true;

          this.currentParams = params;
          this.queryParams = "?" + this.queryStr(params);
          this.loadUser(this.queryParams);
        } else {
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = "?" + this.queryStr(params);
          // console.log(this.queryParams);
          // console.log(this.queryStr(params));
          /* pagination */
          //this.loadworkorder(this.currentParams);
          this.loadUser(this.queryParams);
        }
      });

    //this.LoadJs.loadScriptProductStb()
    //this.LoadJs.loadScriptOrderService()

    // this.partner()
    this.role();
  }

  refreshPage() {
    //this.ngOnInit();
    this.loadStart();
  }

  checkusername() {
    const data = this.formRegister.get("username").value;
    console.log(data);

    return this.partnerService
      .PostCheckNextsysUsername(data)
      .subscribe((output: any) => {
        console.log(output.data);

        if (output.status) {
          this.usernamenotavail = false;
          this.usernameavail = true;
        } else {
          this.usernameavail = false;
          this.usernamenotavail = true;
        }
      });
  }
  checkemail() {
    let data = this.formRegister.get("email").value;
    console.log(data);

    // if( data == Validators.pattern('^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+.[a-zA-Z0-9-.]+$') )
    // {
    // console.log('keren')
    // this.emailfalse = false

    return this.partnerService
      .PostCheckNextsysEmail(data)
      .subscribe((output: any) => {
        console.log(output.data);

        if (output.status) {
          this.emailnotavail = false;
          this.emailavail = true;
        } else {
          this.emailavail = false;
          this.emailnotavail = true;
        }
      });
    // }else{
    //   console.log('jelek')
    //   this.emailfalse = true
    // }
  }
  checksalescode() {
    const data = this.formRegister.get("salescode").value;
    console.log(data);

    // if( data != this.pcodeold){

    return this.partnerService
      .PostCheckNextsysSalesCode(data)
      .subscribe((output: any) => {
        console.log(output.data);

        if (output.status) {
          this.scodenotavail = false;
          this.scodeavail = true;
        } else {
          this.scodeavail = false;
          this.scodenotavail = true;
        }
      });

    // }else{
    //   this.scodeavail = false
    //   this.scodenotavail = false
    // }
  }

  search() {
    if (this.msearch == undefined) {
      this.msearch = "";
    }

    this.querySearch = true;
    //this.searchQueryParams = this.queryParams+'&search='+this.msearch+'&mrole='+this.mrole;
    if (this.mrole == undefined) {
      this.searchQueryParams =
        "?page=" + this.page_self["page"] + "&search=" + this.msearch;
    } else {
      this.searchQueryParams =
        "?page=" +
        this.page_self["page"] +
        "&search=" +
        this.msearch +
        "&mrole=" +
        this.mrole;
    }

    if (this.limit != undefined) {
      this.searchQueryParams += "&limit=" + this.limit;
    }

    this.loadUser(this.searchQueryParams);
  }

  queryStr(options: any) {
    let params = new URLSearchParams();
    for (let key in options) {
      params.set(key, options[key]);
    }
    return params.toString();
  }

  queryStrSearch() {
    if (this.msearch) {
      return "&search=" + this.msearch;
    } else {
      return "";
    }
  }

  clearForm() {
    this.formRegister.reset();
  }

  onActionClick(act: any, item: any) {
    this.alert_act = act;
    // console.log(id, act)
    if (act == "update") {
      this.itemupdate = item;
      console.log(item, this.itemupdate);
    } else if (act == "edit") {
      this.itemedit = item;

      this.formEdit = this.fb.group({
        username: [item.username],
        email: [item.email, [Validators.required]],
      });

      console.log(item, this.itemedit);
    } else if (act == "directsales") {
      this.formDirect.get("nama").setValue(item.datasales.nama);
      this.formDirect.get("nohp").setValue(item.datasales.nohp);
      this.formDirect.get("kota").setValue(item.datasales.kota);
      this.formDirect.get("branch").setValue(item.datasales.branch);

      this.itemdirectsales = item;
      console.log(this.itemdirectsales);
    } else if (act == "delete") {
      this.itemdelete = item;
      console.log(item, this.itemdelete);
    }
  }

  loadUser(params: any) {
    this.table_load = true;

    return this.partnerService
      .GetUserNextsyslist(params)
      .subscribe((output: any) => {
        console.log(output);
        this.userList = output.data;

        this.table_load = false;

        this.paging = output.pagex;
        this.page_self = output.pagex.self;
        this.page_next = output.pagex.next;
        this.page_prev = output.pagex.prev;
        this.meta = output.meta;
        this.total_count = this.meta["totalCount"];
        let self = this.page_self["page"];
        if (self * this.meta["perPage"] < this.meta["totalCount"]) {
          this.last_index = self * this.meta["perPage"];
        } else {
          this.last_index = this.meta["totalCount"];
        }

        this.first_index = (self - 1) * this.meta["perPage"] + 1;
      });
  }

  setvalidatorpartner() {
    this.formRegister.get("partner").setValidators(this.formPartner["partner"]);
    this.formRegister.get("partner").setValue("");
  }
  setvalidatordsales() {
    this.formRegister.controls["salescode"].setValidators(Validators.required);
    this.formRegister.get("salescode").setValue("");
  }
  clearvalidatorpartner() {
    this.formRegister.get("partner").clearValidators();
    this.formRegister.get("partner").setValue("");
  }
  clearvalidatordsales() {
    this.formRegister.get("salescode").clearValidators();
    this.formRegister.get("salescode").setValue("");
  }
  cleardirectsales() {
    this.formDirect.get("nama").setValue("");
    this.formDirect.get("nohp").setValue("");
  }

  partner() {
    // this.formRegister.get('partner').setValue("");

    if (this.roleValue == "PartnerNextsys") {
      this.clearvalidatordsales();
      this.setvalidatorpartner();
      // console.log(this.formRegister.value, "true")
      // this.wicValue = false
      // this.partnerValue = true

      this.partnerService
        .GetListNextsysPartner("")
        .subscribe((response: any) => {
          this.partnerwtowic = response.data;
        });
    } else if (this.roleValue == "OperatorWIC") {
      this.clearvalidatordsales();
      this.setvalidatorpartner();

      // console.log(this.formRegister.value, "true")
      // this.partnerValue = false
      // this.wicValue = true

      this.partnerService
        .GetListNextsysPartner("")
        .subscribe((response: any) => {
          this.partnerwitwic = response.data;
        });
    } else if (this.roleValue == "Superbranch") {
      this.clearvalidatordsales();
      this.setvalidatorpartner();

      this.partnerService.GetPartnersuperbranch().subscribe((response: any) => {
        this.partnersuperbranch = response.data;
      });
    } else if (this.roleValue == "Directsales") {
      this.clearvalidatorpartner();
      this.setvalidatordsales();
    } else {
      this.clearvalidatorpartner();
      this.clearvalidatordsales();
      // console.log(this.formRegister.value, "selain partner")
      // this.formRegister.get('partner').setValidators(this.formPartner['unpartner']);
      // console.log("kok ga masuk")
    }
  }

  role() {
    this.partnerService.GetRole().subscribe((response: any) => {
      this.data_role = response.data;
    });
  }

  submitdatasales(item: any) {
    console.log(this.formDirect.value, "batas", item.datasales.id);

    this.partnerService
      .PostSubmitNextsysDataSales(item.id, this.formDirect.value)
      .subscribe((response: any) => {
        // this.ngOnInit()
        if (response.status == true) {
          this.loadStart();
          this.LoadJs.loadScriptProductStb();
          this.alert_success = true;

          this.successreg = response.data.message;
          setTimeout(() => {
            this.alert_success = false;
          }, 6000);
          this.formRegister.reset();
        } else {
          this.LoadJs.loadScriptProductStb();
          this.alert_failed = true;

          this.errorreg = response.data.message;
          setTimeout(() => {
            this.alert_failed = false;
          }, 6000);
        }

        // this.fileUploader.nativeElement.value = null
      });
  }

  submitRegis() {
    this.alert_failed = false;
    this.alert_success = false;

    // console.log(this.formOrder.value)
    this.partnerService
      .PostRegistrasiNextsysUser(this.formRegister.value)
      .subscribe((response: any) => {
        // this.ngOnInit()
        if (response.status == true) {
          this.loadStart();
          this.LoadJs.loadScriptProductStb();
          this.alert_success = true;

          this.successreg = response.data.message;
          setTimeout(() => {
            this.alert_success = false;
          }, 6000);
          this.formRegister.reset();
        } else {
          this.LoadJs.loadScriptProductStb();
          this.alert_failed = true;

          this.errorreg = response.data.message;
          setTimeout(() => {
            this.alert_failed = false;
          }, 6000);
        }

        // this.fileUploader.nativeElement.value = null
      });
  }

  isconfirm() {
    if (this.formUpdate.value.confirm == "CONFIRMATION") {
      this.confirmation = true;
    } else {
      this.confirmation = false;
    }
  }

  resetUser(item: any) {
    // console.log(this.formUpdate.value)

    this.partnerService
      .PostResetNextsysUser({
        username: item.username,
        post: this.formUpdate.value.password,
      })
      .subscribe((response: any) => {
        // console.log(item, this.formUpdate.value)
        // this.ngOnInit()
        if (response.status == true) {
          // console.log(response)

          this.loadStart();
          this.LoadJs.loadScriptProductStb();
          this.alert_success = true;

          this.successreg = response.data.message;
          setTimeout(() => {
            this.alert_success = false;
          }, 6000);
          this.formRegister.reset();
        } else {
          this.LoadJs.loadScriptProductStb();
          this.alert_failed = true;

          this.errorreg = response.data.message;
          setTimeout(() => {
            this.alert_failed = false;
          }, 6000);
        }

        // this.fileUploader.nativeElement.value = null
      });
  }

  editUser(item: any) {
    //console.log(this.formEdit.value);

    this.partnerService
      .PostEditNextsysUser(item.id, this.formEdit.value)
      .subscribe((response: any) => {
        // console.log(item, this.formUpdate.value)
        // this.ngOnInit()

        if (response.status == true) {
          console.log(response);

          //this.loadStart();
          this.search();
          //this.LoadJs.loadScriptProductStb()
          this.alert_success = true;

          this.successreg = response.data.message;
          setTimeout(() => {
            this.alert_success = false;
          }, 6000);
          this.formEdit.reset();
        } else {
          //this.LoadJs.loadScriptProductStb()
          this.alert_failed = true;

          this.errorreg = response.data.message;
          setTimeout(() => {
            this.alert_failed = false;
          }, 6000);
        }

        // this.fileUploader.nativeElement.value = null
      });
  }

  deleteUser(item: any) {
    console.log(item);

    this.partnerService
      .PostDeleteNextsysUser(item.id)
      .subscribe((response: any) => {
        if (response.status == true) {
          console.log(response);

          this.loadStart();
          //this.search();
          this.alert_success = true;

          this.successreg = response.message;
          setTimeout(() => {
            this.alert_success = false;
          }, 6000);
        } else {
          this.alert_failed = true;

          this.errorreg = response.message;
          setTimeout(() => {
            this.alert_failed = false;
          }, 6000);
        }
        // this.fileUploader.nativeElement.value = null
      });
  }

  NotCompleteData(item) {
    if (item.datasales == null) {
      return true;
    }

    if (
      item.datasales.branch == null ||
      item.datasales.kota == null ||
      item.datasales.nohp == null
    ) {
      return true;
    }

    if (item.datasales.statusid != 1) {
      return true;
    } else {
      return false;
    }
  }

  pickCheck() {
    console.log(this.CheckAll);
    for (let [key, item] of Object.entries(this.userList)) {
      console.log(item);
      this.CheckUser[key] = this.CheckAll;
    }
  }

  pickResetPassword() {
    if (!confirm("Anda yakin untuk reset password pada user yang dipilih ? ")) {
      return false;
    }

    console.log(this.CheckUser);
    for (let [key, value] of Object.entries(this.CheckUser)) {
      if (value) {
        let user = this.userList[key];
        this.flagging[user.id]["resetpassword"] = true;

        this.partnerService
          .PostResetNextsysUser({
            username: user.username,
            post: "mncplaymedia2019",
          })
          .subscribe((response: any) => {
            // console.log(item, this.formUpdate.value)
            // this.ngOnInit()
            if (response.status == true) {
            } else {
            }

            this.flagging[user.id]["resetpassword"] = false;
            this.flagging[user.id]["successresetpassword"] = true;
            // this.fileUploader.nativeElement.value = null
          });
      }
    }
  }

  flag(item, key) {
    if (this.flagging[item.id] == undefined) {
      this.flagging[item.id] = { key: false };
    }

    return this.flagging[item.id][key];
  }
}
